/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import { addMonths } from 'date-fns';
const defaultWidgets = [
    {
        id: 0,
        type: 'Regiões do brasil - distribuição da frota pelo país',
        size: '50%',
        canBeHalf: true,
    },
    { id: 1, type: 'Gráfico de serviços', size: '50%', canBeHalf: true },
    {
        id: 2,
        type: 'Total de atendimentos realizados',
        size: '100%',
        canBeHalf: true,
    },
    {
        id: 3,
        type: 'Entrada e saída de manutenções',
        size: '100%',
        canBeHalf: true,
    },
    {
        id: 4,
        type: 'Distribuição de veículos por idade e km',
        size: '100%',
        canBeHalf: true,
    },
    {
        id: 5,
        type: 'Distribuição de frotas por modelos',
        size: '100%',
        canBeHalf: true,
    },
];
const defaultDashboardCards = [
    {
        content: [defaultWidgets[0], defaultWidgets[1]],
    },
    {
        content: [defaultWidgets[2]],
    },
    {
        content: [defaultWidgets[3]],
    },
    {
        content: [defaultWidgets[4]],
    },
    { content: [defaultWidgets[5]] },
];
const initialState = {
    globalDate: [
        {
            startDate: addMonths(new Date(), -12),
            endDate: new Date(),
            key: 'selection',
        },
    ],
    globalDateUpdate: false,
    globalPeriod: 'Mês',
    widgetsList: [],
    dashboardCards: defaultDashboardCards,
};
const GlobalDataSlicer = createSlice({
    name: 'storage',
    initialState: initialState,
    reducers: {
        setGlobalDate: (state, { payload: globalDate }) => {
            state.globalDate = globalDate;
        },
        updatesGlobalDate: (state, { payload: bool }) => {
            state.globalDateUpdate = bool;
        },
        setGlobalPeriod: (state, { payload: globalPeriod }) => {
            state.globalPeriod = globalPeriod;
        },
        setDashBoardCards: (state, { payload: dashboardCards, }) => {
            if (dashboardCards === null) {
                state.dashboardCards = defaultDashboardCards;
                state.widgetsList = defaultWidgets;
            }
            else {
                state.dashboardCards = dashboardCards;
                const currentIds = [];
                dashboardCards.map(row => row.content.map(item => currentIds.push(item.id)));
                state.widgetsList = defaultWidgets.filter(widget => !currentIds.includes(widget.id));
            }
        },
        addWidget: (state, { payload: { index, id } }) => {
            const addedWidget = defaultWidgets.filter(widget => widget.id === id)[0];
            state.widgetsList = state.widgetsList?.filter(widget => widget.id !== addedWidget.id);
            state.dashboardCards.splice(index, 0, {
                content: [{ ...addedWidget, size: '100%' }],
            });
        },
        removeWidget: (state, { payload: { rowIndex, id }, }) => {
            const removedWidget = defaultWidgets.filter(widget => widget.id === id)[0];
            state.widgetsList.splice(0, 0, removedWidget);
            state.widgetsList = state.widgetsList.sort((a, b) => a.id - b.id);
            const updatedDashboardCards = state.dashboardCards[rowIndex].content.filter(card => card.id !== id);
            state.dashboardCards[rowIndex].content = updatedDashboardCards;
            state.dashboardCards = state.dashboardCards.filter(row => row.content.length > 0);
        },
        setCardSize: (state, { payload: { rowIndex, id, size }, }) => {
            if (state.dashboardCards[rowIndex].content.length > 1 &&
                size === '100%') {
                const resizedWidget = defaultWidgets.filter(widget => widget.id === id)[0];
                state.dashboardCards[rowIndex].content = state.dashboardCards[rowIndex].content.filter(card => card.id !== id);
                state.dashboardCards.splice(rowIndex, 0, {
                    content: [{ ...resizedWidget, size }],
                });
            }
            else {
                const cardIndex = state.dashboardCards[rowIndex].content.findIndex(card => card.id === id);
                state.dashboardCards[rowIndex].content[cardIndex].size = size;
            }
        },
        reorderRows: (state, { payload: { prevIndex, newIndex }, }) => {
            const [removed] = state.dashboardCards.splice(prevIndex, 1);
            state.dashboardCards.splice(newIndex, 0, removed);
        },
        reorderCards: (state, { payload: { rowIndex, prevIndex, newIndex, newRowIndex }, }) => {
            const [removed] = state.dashboardCards[rowIndex].content.splice(prevIndex, 1);
            if (newRowIndex !== undefined) {
                state.dashboardCards[newRowIndex].content.splice(newIndex, 0, removed);
                if (state.dashboardCards[newRowIndex].content[newIndex === 0 ? 1 : 0]
                    .size === '100%')
                    state.dashboardCards[newRowIndex].content[newIndex === 0 ? 1 : 0].size = '50%';
            }
            else {
                state.dashboardCards[rowIndex].content.splice(newIndex, 0, removed);
            }
            state.dashboardCards = state.dashboardCards.filter(row => row.content.length > 0);
        },
        setDefaultWidgets: state => {
            state.widgetsList = [];
            state.dashboardCards = defaultDashboardCards;
        },
        clearGlobalData: () => initialState,
    },
});
export const { setGlobalDate, updatesGlobalDate, setGlobalPeriod, setDashBoardCards, addWidget, removeWidget, setCardSize, reorderRows, reorderCards, setDefaultWidgets, clearGlobalData, } = GlobalDataSlicer.actions;
export default GlobalDataSlicer.reducer;
